import React, { useEffect, useState } from "react";
import { Info, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { isPrivacyAlertDismissed, dismissPrivacyAlert } from "@/lib/device";

// Persistent privacy notice: history is stored per-device (localStorage) and
// will be lost if the user clears cookies / site data. Dismissible.
export default function PrivacyAlert() {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setVisible(!isPrivacyAlertDismissed());
  }, []);

  if (!visible) return null;

  return (
    <div
      className="card-elev border-l-4 border-l-[color:var(--brand)] px-5 py-4 flex items-start gap-3 mb-6 fade-up"
      data-testid="privacy-alert"
      role="alert"
    >
      <div className="w-8 h-8 rounded-full bg-blue-500/15 flex items-center justify-center shrink-0">
        <Info size={16} className="text-[color:var(--brand)]" />
      </div>
      <div className="flex-1 text-sm leading-relaxed">
        <div className="text-white font-semibold mb-1">{t("privacy.title")}</div>
        <div className="text-[color:var(--fg-secondary)]">
          {t("privacy.body_1")}{" "}
          <span className="text-white font-medium">{t("privacy.body_highlight")}</span>{" "}
          {t("privacy.body_2")}
        </div>
      </div>
      <button
        onClick={() => {
          dismissPrivacyAlert();
          setVisible(false);
        }}
        className="p-1 rounded-md hover:bg-white/5 transition-colors shrink-0"
        aria-label={t("privacy.dismiss")}
        data-testid="privacy-alert-dismiss"
      >
        <X size={16} className="text-[color:var(--fg-secondary)]" />
      </button>
    </div>
  );
}
